// The 5 levels come from item 5.5.1 of the technical doc (tarefas/devolutiva-simplificada-quinto-ano/
// V2 - Plano tecnico - Devolutiva simplificada.pdf) — same source of truth already used for the
// star cutoffs (not implemented in code, but the names of the 5 levels are already known).
// DRAFT (2026-09-21): interim copy, written to unblock demo/layout validation — Mari Parro
// (pedagogical) hasn't validated any of these phrases yet (except "confiante", which was already
// real before). Swap for the final copy as soon as she delivers it; don't treat as final copy.
const SIMPLIFIED_FEEDBACK_LEVEL_SUPPORT_PHRASES: Record<string, string> = {
  'Escritor(a) começando':
    'Você está no início da sua jornada como escritor(a). Continue praticando!',
  'Escritor(a) explorador(a)':
    'Você está explorando novos jeitos de escrever. Siga em frente!',
  'Escritor(a) aprendiz':
    'Você já aprendeu bastante e está avançando bem. Continue assim!',
  'Escritor(a) confiante': 'Você já escreve com bastante segurança. Muito bem!',
  'Escritor(a) craque':
    'Você escreve muito bem, com segurança de sobra. Parabéns!',
};

export function getSimplifiedFeedbackLevelSupportPhrase(
  levelLabel: string,
): string | null {
  return SIMPLIFIED_FEEDBACK_LEVEL_SUPPORT_PHRASES[levelLabel] ?? null;
}
